module.exports = __webpack_public_path__ + "media/images/icons/orders-9b03da1d1e28b366fcb88afc5ba6c3c3.gif";